/* eslint-disable no-restricted-globals */
/* eslint-disable consistent-return */
/* eslint-disable no-undef */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-array-index-key */

import React, { Component, createRef } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import _ from "underscore";

import Moment from "moment";
import { extendMoment } from "moment-range";
import ReactMarkdown from "react-markdown";

import * as brazeActions from "../../redux/actions/braze";
import * as ccDetailsActions from "../../redux/actions/ccDetails";
import * as checkoutActions from "../../redux/actions/checkout";
import * as elementsActions from "../../redux/actions/elements";
import * as guestUserActions from "../../redux/actions/guestUser";
import * as orderActions from "../../redux/actions/order";
import * as paymentActions from "../../redux/actions/payment";
import * as productActions from "../../redux/actions/product";
import * as userActions from "../../redux/actions/user";

import Button from "../../components/Button/Button";
import CheckBox from "../../components/CheckBox/CheckBox";
import CheckoutAlertInline from "../../components/CheckOutContainer/CheckoutAlertInline/CheckoutAlertInline";
import ContactDetailsWidget from "../../components/ContactDetailsWidget/ContactDetailsWidget";
import Input from "../../components/Input/Input";
import Loader from "../../components/Loader/Loader";
import PaymentWidget from "../../components/PaymentWidget/PaymentWidget";
import SecondaryInput from "../../components/SecondaryInput/SecondaryInput";
import cmsKeys from "../../shared/constants/cms";
import { defaultCurrency } from "../../shared/constants/currency";
import endpoints from "../../shared/constants/endpoints";
import errorCodes from "../../shared/constants/errorCodes";
import {
  orderCompleteRequirementClassNames,
  orderCompleteRequirementMessages,
  checkoutRequirementScrollHeaderOffset,
  orderMethods,
  orderTypeIds
} from "../../shared/constants/order";
import paymentMethods from "../../shared/constants/paymentMethods";
import subscription from "../../shared/constants/subscription";
import MOBILE_SIZE from "../../shared/constants/size";
import * as cms from "../../shared/repos/cms/cms";
import {
  getErrorMessages,
  getErrorReasons,
  isMobile,
  routeCountryPath
} from "../../shared/utilities/common";
import amplitudeAnalytics, {
  AMPLITUDE_NAV_SECTION_SECONDARY,
} from "../../shared/utilities/amplitude";
import {
  openAddressMissingOrderModal,
  openUnavailableOrderProductModal
} from "../../shared/utilities/modals";
import {
  checkoutOrderMinAmount,
  checkoutWithNoItems,
  clearCart,
  getCartSubtotal,
  isDoughProOrder
} from "../../shared/utilities/orders";
import { getTotalPrice } from "../../shared/utilities/renderings";
import { getCustomerSubscriptions } from "../../shared/utilities/subscription";
import * as tagmanagerEvents from "../../shared/utilities/tagmanagerEvents";
import GiftRecipient from "./GiftRecipient/GiftRecipient";
import ShippingAddress from "./ShippingAddress/ShippingAddress";
import ShippingMethods from "./ShippingMethods/ShippingMethods";

import ToggleDeliveryPickup from "./ToggleDeliveryPickup/ToggleDeliveryPickup";
import {
  deliveryRendering,
  pickUpRenderings,
  returnLineCost
} from "./rendering";

import * as doughProRepo from "../../shared/repos/graphql/doughPro";
import * as orderRepo from "../../shared/repos/graphql/order";

// STYLES
import "@brainhubeu/react-carousel/lib/style.css";
import CmsInlineEdit from "../../components/Cms/CmsInlineEdit";
import UpsellProducts from "../../components/Header/UpsellProducts/UpsellProducts";
import EmbeddedPaymentMethod from "../../components/PaymentWidget/EmbeddedPaymentMethod/EmbeddedPaymentMethodGroup";
import {
  getPaymentMethodGroups,
  uiComponentTypes
} from "../../components/PaymentWidget/shared";
import { store } from "../../redux/store";
import { OrderEvent } from "../../shared/constants/OrderEvent";
import messages from "../../shared/constants/messages";
import orderTotals from "../../shared/constants/orderTotals";
import { storeIds } from "../../shared/constants/store";
import windowNames from "../../shared/constants/windowNames";
import { client } from "../../shared/utilities/config";
import log from "../../shared/utilities/datadog/log";
import { isStoreClosed } from "../../shared/utilities/store";
import * as validations from "../../shared/utilities/validations";
import profileStyles from "../Profile/Profile.module.css";
import UpsellProduct from "../UpsellProduct/UpsellProduct";
import styles from "./ReviewOrder.module.css";
import "./ReviewOrderBrandRefresh.module.css";
import PlaceOrderLoader from "../../components/Loader/PlaceOrderLoader";
import {
  getCheckoutBackIcon,
  getCheckoutCheckIconSrc,
  getCheckoutPartProps,
  getCheckoutRegionProps,
  getOrderItemLabel,
  getOrderItemLineAmount,
  isReviewOrderBrandRefresh,
} from "./reviewOrderBrandRefreshClasses";
import {
  needsLocationAccessAcknowledgement,
  normalizeLocationAccessStoreId
} from "../../shared/utilities/locationAccessAcknowledgement";

const backIcon = require("./imgs/back-icon.svg");
const LightBackIcon = require("./imgs/light-back-icon.svg");
const brandRefreshBackIcon = require("./imgs/brand-refresh-back-icon.svg");

const moment = extendMoment(Moment);

const getLocationAccessCheckoutStatePatch = (
  prevState,
  order,
  acknowledgedStoreId
) => {
  const nextStoreId = normalizeLocationAccessStoreId(order?.store?.id);
  const prevStoreId = normalizeLocationAccessStoreId(prevState.order?.store?.id);
  const storeChanged =
    prevStoreId != null &&
    nextStoreId != null &&
    nextStoreId !== prevStoreId;
  if (storeChanged) {
    return {
      locationAccessCheckoutConfirmed: false
    };
  }
  if (
    nextStoreId &&
    normalizeLocationAccessStoreId(acknowledgedStoreId) === nextStoreId &&
    needsLocationAccessAcknowledgement(order?.store)
  ) {
    return { locationAccessCheckoutConfirmed: true };
  }
  return {};
};

const applyLocationAccessStoreChange = (
  previousOrder,
  nextOrder,
  locationAccessAcknowledgedStoreId,
  setLocationAccessAcknowledgedStoreId
) => {
  const prevStoreId = normalizeLocationAccessStoreId(previousOrder?.store?.id);
  const nextStoreId = normalizeLocationAccessStoreId(nextOrder?.store?.id);
  const storeChanged =
    prevStoreId != null &&
    nextStoreId != null &&
    nextStoreId !== prevStoreId;

  if (storeChanged) {
    setLocationAccessAcknowledgedStoreId(null);
  }

  return {
    ackForPatch: storeChanged ? null : locationAccessAcknowledgedStoreId
  };
};

class ReviewOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // eslint-disable-next-line react/no-unused-state
      customAddress: null, // eslint-disable-line
      promoCode: "", // eslint-disable-line
      promoCodes: [], // eslint-disable-line
      promoError: null, // eslint-disable-line
      deliveryTime: null,
      order: null,
      selectedDeliveryDate: null,
      availableStoreHours: [],
      isGift: false,
      selectedDeliveryTime: null,
      total: 0,
      schoolCashNumber: "",
      orderOTP: null,
      sendingOTP: false,
      completeOrderErrorCode: null,
      completeOrderProcessing: false,
      orderCompleted: false,
      optInSelection: [],
      customerSubscriptions: [],
      deliveryAddressOpen: true,
      subscriptionsList: [],
      previousTotal: 0.0,
      embeddedPaymentMethod: null,
      isFormCompleted: false,
      dropoffOrigin: null,
      dropoffCandidate: null,
      dropoffDirty: false,
      dropoffValid: false,
      dropoffSaving: false,
      dropoffDistance: 0,
      orderLoadError: null,
      isMobileViewport: isMobile(),
      locationAccessCheckoutConfirmed: false,
    };
    this.smsDisclaimerRef = createRef();
    this.textDisclaimerRef = createRef();
  }

  componentDidMount() {
    const { match, checkout, setSaveCheckoutDetails, userAddress } = this.props;
    const { address2 } = this.state;

    const orderCode = match.params.id;
    this.setState({
      orderCode
    });

    this.getOrder(orderCode);
    cms.getContent(
      [
        cmsKeys.checkoutPage.disclaimerNote,
        cmsKeys.checkoutPage.disclaimerSMSNote,
        cmsKeys.placeholders.checkoutDeliveryAddressApartment,
        ...Object.values(cmsKeys.checkoutPage.payments.discounts.callouts)
      ],
      this
    );
    this.loadCustomerSubscriptions();
    this.updatePaymentCredentials(null);

    const { userCart, currency, userOrderMethod } = this.props;

    log.logInfo("[checkout][review-order] ", {
      orderCode,
      userCart,
      currency,
      userOrderMethod
    });
    const { saveCheckoutDetails } = checkout;
    if (userAddress?.savedLocation?.addressDetails?.address2) {
      const address2Value =
        saveCheckoutDetails && saveCheckoutDetails.aptNo
          ? saveCheckoutDetails.aptNo
          : address2;
      const address2ValueFromSavedAddresses = userAddress?.savedLocation
        ?.addressDetails?.address2
        ? userAddress?.savedLocation?.addressDetails?.address2
        : address2Value;
      setSaveCheckoutDetails({ aptNo: address2ValueFromSavedAddresses });
      this.setState({ address2: address2ValueFromSavedAddresses });
    }
    this.checkoutStarted(orderCode);
    window.addEventListener("resize", this.handleViewportResize);
  }

  componentDidUpdate(prevProps, prevState) {
    const { match: prevMatch } = prevProps;
    const { match } = this.props;
    const { order, checkout } = this.props;
    const {
      order: stateOrder,
      embeddedPaymentMethod,
    } = this.state;
    const {
      order: prevOrder,
      checkout: prevCheckout,
    } = prevProps;
    const {
      order: prevStateOrder,
      embeddedPaymentMethod: prevEmbeddedPaymentMethod,
    } = prevState;
    const orderPropsChanged =
      prevOrder !== order ||
      prevOrder?.totals !== order?.totals;
    const shouldSetOrderFromProps = orderPropsChanged || (!stateOrder && order);
    if (prevMatch?.params?.id !== match?.params?.id) {
      this.amplitudeViewCheckoutTrackedCode = null;
    }
    if (prevProps !== this.props) {
      this.redirectIfCartInvalid();
      this.resetTip(prevProps.order?.orderTypeId);
      if (shouldSetOrderFromProps) {
        this.setOrderFromProps();
      }
      this.resetDropoff();
    }
    if (this.shouldSyncRequirementError(prevProps, prevState)) {
      this.syncRequirementError();
    }
    const orderStateChanged =
      prevStateOrder !== stateOrder ||
      prevStateOrder?.totals !== stateOrder?.totals;
    const tipChanged = prevCheckout?.tip !== checkout?.tip;
    const embeddedPaymentMethodChanged =
      prevEmbeddedPaymentMethod !== embeddedPaymentMethod;
    if (
      orderStateChanged ||
      (orderPropsChanged && stateOrder === order) ||
      (!orderPropsChanged && (tipChanged || embeddedPaymentMethodChanged))
    ) {
      this.syncTotal();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleViewportResize);
    this.clearCart();
    this.clearContentCardSession();
  }

  setOrderFromProps() {
    const {
      order,
      locationAccessAcknowledgedStoreId,
      setLocationAccessAcknowledgedStoreId
    } = this.props;
    const { order: stateOrder } = this.state;
    const { ackForPatch } = applyLocationAccessStoreChange(
      stateOrder,
      order,
      locationAccessAcknowledgedStoreId,
      setLocationAccessAcknowledgedStoreId
    );
    this.setState(prevState => ({
      order,
      ...getLocationAccessCheckoutStatePatch(prevState, order, ackForPatch)
    }));
  }

  getOrder(orderCode) {
    const { paymentCredentials } = this.props;
    if (!orderCode) {
      return;
    }

    let orderParams = null;
    if (paymentCredentials) {
      orderParams = {
        paymentCredential: paymentCredentials
      };
    }

    const { order } = store.getState();

    if (
      order === null ||
      !order.shippingAddress?.lat ||
      !order.shippingAddress?.lng
    ) {
      this.setState({ orderLoading: true });

      orderRepo
        .getOrder(orderCode, orderParams)
        .then(response => this.setOrder(response.data.order))
        .catch(reason => {
          const message = getErrorMessages(reason, 0) || reason?.message;
          this.setState({
            orderLoading: false,
            orderLoadError: message
          });
        });
    } else {
      this.setOrder(order);
    }
  }

  shouldSyncRequirementError = (prevProps, prevState) => {
    const {
      completeOrderError,
      selectedDeliveryTime,
      previousTotal,
      order,
    } = this.state;
    const { paymentCredentials, userOrderMethod, checkout } = this.props;

    if (!completeOrderError) {
      return false;
    }

    if (!Object.values(orderCompleteRequirementMessages).includes(completeOrderError)) {
      return false;
    }

    return (
      prevState.completeOrderError !== completeOrderError
      || prevState.selectedDeliveryTime !== selectedDeliveryTime
      || prevState.previousTotal !== previousTotal
      || prevState.order !== order
      || prevProps.paymentCredentials !== paymentCredentials
      || prevProps.userOrderMethod !== userOrderMethod
      || prevProps.checkout !== checkout
    );
  };

  syncRequirementError = () => {
    const { completeOrderError } = this.state;

    if (
      !completeOrderError
      || !Object.values(orderCompleteRequirementMessages).includes(completeOrderError)
    ) {
      return;
    }

    const { message } = this.getRequirementMessagesData();

    if (!isReviewOrderBrandRefresh()) {
      if (completeOrderError !== message) {
        this.setState({ completeOrderError: null });
      }
      return;
    }

    if (!message) {
      if (completeOrderError) {
        this.setState({ completeOrderError: null });
      }
      return;
    }

    if (completeOrderError !== message) {
      this.setState({ completeOrderError: message });
    }
  };

  handleViewportResize = () => {
    const { isMobileViewport } = this.state;
    const nextIsMobileViewport = window.innerWidth <= MOBILE_SIZE.width;
    if (nextIsMobileViewport !== isMobileViewport) {
      this.setState({ isMobileViewport: nextIsMobileViewport });
    }
  };

  checkoutStarted = orderCode => {
    if (orderCode) {
      const { userCart, order } = this.props;
      const customerId = order?.customer?.id;
      const checkoutUrl = window.location.href;
      if (userCart && userCart.length > 0) {
        tagmanagerEvents.beginCheckout(orderCode, userCart, customerId);
      }
      orderRepo
        .orderEvent(OrderEvent.CHECKOUT_STARTED, orderCode, { checkoutUrl })
        .then(() => {});
    }
  };

  clearCart = () => {
    const { orderCompleted } = this.state;

    if (orderCompleted) {
      clearCart(null, { clearUserAddress: false });
    }
  };

  clearContentCardSession = () => {
    const { contentCardSession } = this.props;

    if (window.name === windowNames.CONTENT_CARD_SESSION) {
      window.name = "";
    }

    contentCardSession(false);
  };

  checkoutOrderMinAmount = order => {
    const { userCart, currency, userOrderMethod, userCartId } = this.props;

    if (!userCart || userCart.length <= 0) {
      if (userOrderMethod === orderMethods.delivery) {
        orderRepo.orderEvent(OrderEvent.CHECKOUT_ATTEMPTED, userCartId, {
          cartSubtotal: 0,
          productIds: []
        });
        checkoutOrderMinAmount(order?.shippingMethodMinAmount, currency.symbol);
      } else {
        checkoutWithNoItems();
      }
    }
  };

  setOrder = order => {
    const { orderUpdated, checkoutUpdated, checkout } = this.props;
    const cartTotal = order.totals.find(
      item => item.title.toLowerCase() === "total"
    ).value;
    const cartTip = order.totals.find(
      item => item.title.toLowerCase() === "tip"
    ).value;

    this.checkoutOrderMinAmount(order);

    if (order.recipient) {
      this.setState({
        isGift: true
      });
    }
 
    const {
      locationAccessAcknowledgedStoreId,
      setLocationAccessAcknowledgedStoreId
    } = this.props;
    const { order: stateOrder } = this.state;
    const { ackForPatch } = applyLocationAccessStoreChange(
      stateOrder,
      order,
      locationAccessAcknowledgedStoreId,
      setLocationAccessAcknowledgedStoreId
    );

    this.setState(prevState => ({
      order,
      total: cartTotal,
      ...getLocationAccessCheckoutStatePatch(prevState, order, ackForPatch)
    }));

    if (order.shippingAddress2) {
      this.setState({ address2: order.shippingAddress2 });
    }

    // Initialize dropoff origin from shipping address if available for delivery orders
    if (
      order.orderTypeId === orderTypeIds.delivery &&
      order.shippingAddress?.lat &&
      order.shippingAddress?.lng
    ) {
      log.logInfo(
        "[ReviewOrder] Initializing dropoff from order.shippingAddress",
        {
          lat: order.shippingAddress.lat,
          lng: order.shippingAddress.lng
        }
      );

      this.setState({
        dropoffOrigin: {
          lat: order.shippingAddress.lat,
          lng: order.shippingAddress.lng
        },
        dropoffCandidate: {
          lat: order.shippingAddress.lat,
          lng: order.shippingAddress.lng
        }
      });
    }

    orderUpdated(order);
    checkout.tip = cartTip;
    checkoutUpdated(checkout);

    if (order?.code && Array.isArray(order.items) && order.items.length > 0) {
      if (this.amplitudeViewCheckoutTrackedCode !== order.code) {
        this.amplitudeViewCheckoutTrackedCode = order.code;
        try {
          amplitudeAnalytics.trackViewCheckout(order, store.getState());
        } catch {
          /* Amplitude must not affect checkout */
        }
      }
    }

    orderRepo
      .getOrderEstimate(order.code)
      .then(response => {
        const errors = response?.errors;
        const message = errors?.length > 0 ? errors[0].message || null : null;
        if (message) {
          this.setState({ orderLoadError: message, orderLoading: false });
        } else {
          this.setState({ orderLoading: false });
        }
      })
      .catch(reason => {
        const message = getErrorMessages(reason, 0) || reason?.message;
        this.setState({ orderLoadError: message, orderLoading: false });
      });
  };

  castTitle = title => {
    const { orderTotalsTitles } = this.props;
    const orderTotalsLabels = orderTotalsTitles
      ? JSON.parse(orderTotalsTitles)
      : null;
    if (orderTotalsLabels && orderTotalsLabels[title] !== undefined) {
      return orderTotalsLabels[title];
    }
    return title;
  };

  getDisclaimerNotes = () => {
    const { content } = this.state;
    return _.find(content, { key: cmsKeys.checkoutPage.disclaimerNote });
  };

  getDisclaimerSMSNotes = () => {
    if (!this.shouldRenderPhoneOptInOptions()) {
      return "";
    }
    const { content } = this.state;
    return _.find(content, { key: cmsKeys.checkoutPage.disclaimerSMSNote });
  };

  resetTip = prevOrderTypeId => {
    const { order, checkout, checkoutUpdated } = this.props;
    const isPickup = order?.orderTypeId === orderTypeIds.pickup;
    const currentTip = checkout.tip;
    if (
      order?.orderTypeId !== prevOrderTypeId &&
      isPickup &&
      currentTip > 0
    ) {
      checkoutUpdated({ tip: 0 });
      this.setState({ previousTotal: null });
    }
  };

  resetDropoff = () => {
    // Initialize dropoff coordinates when order.shippingAddress becomes available
    const { order } = this.props;
    const { dropoffOrigin } = this.state;
    if (
      order?.orderTypeId === orderTypeIds.delivery &&
      order?.shippingAddress?.lat &&
      order?.shippingAddress?.lng &&
      !dropoffOrigin
    ) {
      this.setState({
        dropoffOrigin: {
          lat: order.shippingAddress.lat,
          lng: order.shippingAddress.lng
        },
        dropoffCandidate: {
          lat: order.shippingAddress.lat,
          lng: order.shippingAddress.lng
        }
      });
    }
  };

  taxes = () => {
    const { order } = this.state;
    const { currency } = this.props;
    const lineCostType = "orderTotal";
    let serviceFeeTotal = null;
    return (
      <div>
        {order.totals
          .filter(total => {
            const isTax =
              total.title.toLowerCase() === orderTotals.tax.title.toLowerCase();
            if (isTax) {
              return true;
            }

            if (
              orderTotals.serviceFee.title.toLowerCase() ===
              total.title.toLowerCase()
            ) {
              serviceFeeTotal = total;

              return false;
            }

            return false;
          })
          .map(total => {
            if (
              orderTotals.tax.title.toLowerCase() ===
                total.title.toLowerCase() &&
              serviceFeeTotal
            ) {
              return (
                <details className={styles.returnLineCostDetails}>
                  <summary>
                    <p>Taxes &amp; Fees</p>
                    <p>
                      {currency.symbol}
                      {total.value.toFixed(2)}
                    </p>
                  </summary>
                  {returnLineCost(
                    total.title,
                    (total.value - serviceFeeTotal.value).toFixed(2),
                    false,
                    currency,
                    lineCostType
                  )}
                  {returnLineCost(
                    serviceFeeTotal.title,
                    serviceFeeTotal.value.toFixed(2),
                    false,
                    currency,
                    lineCostType
                  )}
                </details>
              );
            }

            return returnLineCost(
              total.title,
              total.value,
              false,
              currency,
              lineCostType,
              false,
              false,
              null,
              false
            );
          })}
      </div>
    );
  };

  totals = () => {
    const { order } = this.state;
    const { checkout, currency, showTaxesAfterTotal } = this.props;
    const lineCostType = "orderTotal";
    const isBrandRefresh = isReviewOrderBrandRefresh();

    let serviceFeeTotal = null;

    const usedPoints = order?.orderRedeemables?.reduce(
      (accumulator, currentValue) => {
        return accumulator + currentValue.points;
      },
      0
    );

    const hasDeliveryDiscount = this.getHasDeliveryDiscount(order);

    // Brand refresh (Figma 9396:75663): flat fee rows inside cream cart — no white card / extra divider
    const feeRows = (
      <>
        {order.totals
          .filter(total => {
            const isPickup = order?.orderTypeId === orderTypeIds.pickup;
            const isDeliveryRow =
              total.title.toLowerCase() ===
                orderTotals.delivery.title.toLowerCase() ||
              total.title.toLowerCase() ===
                orderTotals.extendedDelivery.title.toLowerCase();
            if (isPickup && isDeliveryRow) {
              return false;
            }
            const isTotal =
              total.title.toLowerCase() ===
              orderTotals.total.title.toLowerCase();
            const isCoupons =
              total.title.toLowerCase() ===
              orderTotals.coupons.title.toLowerCase();
            const isRewardRedemption =
              total.title.toLowerCase() ===
              orderTotals.rewardRedemption.title.toLowerCase();
            const isTax =
              total.title.toLowerCase() === orderTotals.tax.title.toLowerCase();
            if (isTax && showTaxesAfterTotal) {
              return false;
            }
            // Hide "Delivery Fee Discount" line
            if (total.title.toLowerCase().includes("delivery fee discount")) {
              return false;
            }
            let hasValue = parseFloat(total.value).toFixed(2) !== "0.00";

            if (
              (total.value === 0 || total.value === "Free") &&
              isDeliveryRow
            ) {
              Object.assign(total, { value: "Free" });

              hasValue = true;
            }

            if (
              orderTotals.serviceFee.title.toLowerCase() ===
              total.title.toLowerCase()
            ) {
              serviceFeeTotal = total;

              return false;
            }

            return !isTotal && !isCoupons && !isRewardRedemption && hasValue;
          })
          .map(total => {
            const isloyalty =
              total.title.toLowerCase() ===
              orderTotals.loyalty.title.toLowerCase();
            if (
              orderTotals.tax.title.toLowerCase() ===
                total.title.toLowerCase() &&
              serviceFeeTotal
            ) {
              return (
                <details className={styles.returnLineCostDetails}>
                  <summary>
                    <p>Taxes &amp; Fees</p>
                    <p>
                      {currency.symbol}
                      {total.value.toFixed(2)}
                    </p>
                  </summary>
                  {returnLineCost(
                    total.title,
                    (total.value - serviceFeeTotal.value).toFixed(2),
                    false,
                    currency,
                    lineCostType,
                    true,
                    false,
                    null,
                    false
                  )}
                  {returnLineCost(
                    serviceFeeTotal.title,
                    serviceFeeTotal.value.toFixed(2),
                    false,
                    currency,
                    lineCostType,
                    true,
                    false,
                    null,
                    false
                  )}
                </details>
              );
            }

            const isTip =
              total.title.toLowerCase() === orderTotals.tip.title.toLowerCase();
            if (isTip) {
              return returnLineCost(
                total.title,
                checkout.tip,
                isloyalty,
                currency,
                lineCostType,
                true,
                false,
                null,
                false
              );
            }

            if (
              hasDeliveryDiscount &&
              (total.title.toLowerCase() ===
                orderTotals.delivery.title.toLowerCase() ||
                total.title.toLowerCase() ===
                  orderTotals.extendedDelivery.title.toLowerCase())
            ) {
              const deliveryOriginal = total.value;
              const deliveryNumeric =
                deliveryOriginal === "Free" || deliveryOriginal === 0
                  ? 0
                  : parseFloat(deliveryOriginal);
              const afterDiscount = Number.isFinite(deliveryNumeric)
                ? Math.max(0, deliveryNumeric - order.deliveryFeeDiscount)
                : 0;
              const displayPrice =
                deliveryOriginal === "Free" && afterDiscount === 0
                  ? "Free"
                  : afterDiscount;
              return returnLineCost(
                total.title,
                displayPrice,
                false,
                currency,
                lineCostType,
                true,
                false,
                deliveryOriginal,
                true
              );
            }

            return returnLineCost(
              total.title,
              total.value,
              isloyalty,
              currency,
              lineCostType,
              true,
              false,
              null,
              false
            );
          })}

        {order.discounts.map(cartTotal => {
          let discountLabel = cartTotal.title;
          if (isBrandRefresh && discountLabel) {
            const hasPrefix = /^(coupon|giftcard)\s*:/i.test(discountLabel);
            if (!hasPrefix) {
              discountLabel = `Coupon: ${discountLabel}`;
            }
          }
          return returnLineCost(
            discountLabel,
            cartTotal.value,
            true,
            currency,
            lineCostType,
            true,
            false,
            null,
            false
          );
        })}

        {order.totals
        .filter(total => {
          return total.title.toLowerCase() === orderTotals.rewardRedemption.title.toLowerCase()
            && parseFloat(total.value) !== 0;
        })
        .map(total => {
          return returnLineCost(
            total.title,
            Math.abs(total.value),
            true,
            currency,
            lineCostType,
            true,
            false,
            null,
            false
          );
        })}

        {usedPoints > 0 && (
          <>
            {!isBrandRefresh ? <div className="border-t-[1px]" /> : null}
            {returnLineCost(
              "Points Redeemed",
              usedPoints,
              false,
              currency,
              lineCostType,
              true,
              true,
              null,
              false
            )}
          </>
        )}
      </>
    );

    if (isBrandRefresh) {
      return feeRows;
    }

    return (
      <div className="bg-white dark:bg-dark px-4 shadow-md">
        <div className="border-t-[1px]" />
        {feeRows}
      </div>
    );
  };

  renderOtpInput = () => {
    const { completeOrderErrorCode } = this.state;
    const errors = [
      errorCodes.COMPLETE_ORDER_OTP_REQUIRED,
      errorCodes.COMPLETE_ORDER_OTP_INVALID,
      errorCodes.COMPLETE_ORDER_OTP_EXPIRED,
      errorCodes.COMPLETE_ORDER_TOO_MANY_OTP_ATTEMPTS
    ];

    if (errors.indexOf(completeOrderErrorCode) === -1) {
      return null;
    }

    return (
      <div className="OtpInputWrapper">
        <SecondaryInput
          component={this}
          state="orderOTP"
          label="Enter order OTP"
          isEdit
        />
      </div>
    );
  };

  renderOtpResendBtn = () => {
    const { completeOrderErrorCode, sendingOTP } = this.state;

    const errors = [
      errorCodes.COMPLETE_ORDER_OTP_INVALID,
      errorCodes.COMPLETE_ORDER_OTP_EXPIRED
    ];

    if (errors.indexOf(completeOrderErrorCode) === -1) {
      return null;
    }

    return (
      <button
        className="otpResendBtn"
        onClick={() => this.resendOTP()}
        tabIndex={0}
        onKeyDown={e => e.key === "Enter" && this.resendOTP()}
        type="button"
      >
        {sendingOTP ? "Sending ..." : "Resend OTP"}
      </button>
    );
  };

  backToMenu = () => {
    const {
      history,
      setModalObject,
      setUserCart,
      setUserCartId,
      setUserAddress,
      setSelectedStore,
      setUserOrderMethod
    } = this.props;
    setUserCart([]);
    setUserCartId(null);
    setModalObject(null);
    setUserAddress("");
    setSelectedStore(null);
    setUserOrderMethod("");
    history.push(routeCountryPath(endpoints.getMenuUrl(null)));
  };

  goToEditOrderFromCheckout = () => {
    const { history } = this.props;
    amplitudeAnalytics.trackClickNavSecondary({
      navElement: "Edit Order",
      navSection: AMPLITUDE_NAV_SECTION_SECONDARY.CHECKOUT,
      pathname: history.location?.pathname,
    });
    history.push(routeCountryPath(endpoints.checkoutViewOrderPage));
  };

  renderOrderProcessingModal = (param, message) => {
    const { setModalObject } = this.props;
    const { completeOrderProcessing } = this.state;
    if (param || completeOrderProcessing) {
      if (message) {
        setModalObject(
          openUnavailableOrderProductModal(this.backToMenu, message)
        );
      }
    } else {
      setModalObject(null);
    }
  };

  setDefaultDeliveryTime = deliveryTime => {
    this.setState({ selectedDeliveryTime: deliveryTime });
  };

  resendOTP = async () => {
    const { match } = this.props;
    const { sendingOTP } = this.state;
    const orderCode = match.params.id;

    if (sendingOTP) {
      return;
    }

    this.setState({
      sendingOTP: true
    });

    await orderRepo.generateOrderOtp(orderCode);

    this.setState({
      sendingOTP: false,
      completeOrderErrorCode: errorCodes.COMPLETE_ORDER_OTP_REQUIRED,
      completeOrderError: "",
      orderOTP: null
    });
  };

  /**
   *
   * @param {String} subscriptionId
   * @return {Promise<void>}
   */
  toggleOptInUpdate = (subscriptionId, keyField = null) => {
    const { optInSelection } = this.state;
    const arrayList = [...optInSelection];
    const array = arrayList.includes(subscriptionId)
      ? _.without(arrayList, subscriptionId)
      : _.union(arrayList, [subscriptionId]);
    this.setState({
      optInSelection: array
    });

    if (keyField === "phone") {
      this.smsDisclaimerRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest"
      });
    } else if (keyField === "email") {
      this.textDisclaimerRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest"
      });
    }
  };

  /**
   *
   * @param {error} form error
   * @return {boolean}
   */
  setContactFormError = error => {
    if ((!_.isEmpty(error) && error) || !this.checkOrderValidation()) {
      this.setState({
        isFormCompleted: false
      });
    } else {
      this.setState({
        isFormCompleted: true
      });
    }
  };

  /**
   * Load customer subscriptions
   * @return {Promise<void>}
   */
  loadCustomerSubscriptions = async () => {
    const {
      setAlertRecipientPhoneUpdated,
      setAlertSenderPhoneUpdated,
      alertRecipientPhone,
      alertSenderPhone
    } = this.props;
    const customerSubscriptions = await getCustomerSubscriptions();
    const optInSelection = [];

    _.forEach(customerSubscriptions, item => {
      if (
        (item.customerIdentifier === null && item.defaultValue === true) ||
        item.customerIdentifier !== null
      ) {
        optInSelection.push(item.subscriptionId);
      }
    });

    this.setState({
      optInSelection,
      customerSubscriptions
    });

    // Toggle gift recipient & sender order status checkbox state.
    const orderStatusUpdateSubscription = _.find(customerSubscriptions || [], {
      keyField: subscription.subscriptionKeyField.ORDER_NOTIFICATION
    });

    // Set recipient order status checkbox to default value
    const alertRecipientSenderPhoneDefaultValue =
      orderStatusUpdateSubscription?.defaultValue;
    if (alertRecipientPhone !== alertRecipientSenderPhoneDefaultValue) {
      setAlertRecipientPhoneUpdated(alertRecipientSenderPhoneDefaultValue);
    }

    // Set sender order status checkbox to default value if not subscribed
    if (orderStatusUpdateSubscription) {
      if (orderStatusUpdateSubscription.customerIdentifier === null) {
        if (alertSenderPhone !== alertRecipientSenderPhoneDefaultValue) {
          setAlertSenderPhoneUpdated(alertRecipientSenderPhoneDefaultValue);
        }
      } else {
        setAlertSenderPhoneUpdated(true);
      }
    }
  };

  onLocationAccessCheckoutChange = confirmed => {
    this.setState({ locationAccessCheckoutConfirmed: confirmed });
  };

  isLocationAccessCheckoutBlockingOrder = () => {
    const { order, locationAccessCheckoutConfirmed } = this.state;
    if (order?.orderTypeId !== orderTypeIds.pickup) {
      return false;
    }
    return (
      needsLocationAccessAcknowledgement(order?.store) &&
      !locationAccessCheckoutConfirmed
    );
  };

  /**
   * Render opt-in section
   * @return {JSX.Element|null}
   */
  renderOptInSection = () => {
    const { customerSubscriptions, optInSelection } = this.state;
    const { isCountrySelectActive, selectedCountry } = this.props;
    const isOptInVisible = this.shouldRenderOptInOptions();
    const { optIn } = subscription.subscriptionType;
    const { titleLabel } = subscription;
    const isBrandRefresh = isReviewOrderBrandRefresh();
    return isOptInVisible ? (
      <div data-part={getCheckoutPartProps("opt-in-section")}>
        <div
          className={isBrandRefresh ? undefined : profileStyles.optInContainer}
          data-part={getCheckoutPartProps("opt-in-title")}
        >
          <h3 className={isBrandRefresh ? undefined : "text-dark dark:text-white"}>
            {titleLabel}
          </h3>
        </div>
        <div
          className={isBrandRefresh ? undefined : profileStyles.optInOptions}
          data-part={getCheckoutPartProps("opt-in-options")}
        >
          {customerSubscriptions.map(item => {
            const hasCustomerOptedIn =
              item.customerIdentifier === null &&
              optIn === item.subscriptionTypeId;
            return hasCustomerOptedIn ? (
              <div
                key={item.subscriptionId}
                data-part={getCheckoutPartProps("opt-in-row")}
              >
                <CheckBox
                  onClick={() =>
                    this.toggleOptInUpdate(item.subscriptionId, item.keyField)}
                  label={
                    isBrandRefresh ? (
                      <span data-part={getCheckoutPartProps("opt-in-copy")}>
                        <span data-part={getCheckoutPartProps("opt-in-label")}>
                          {`${item.name}${
                            isCountrySelectActive
                              ? ` (${selectedCountry.short_name})`
                              : ''
                          }`}
                        </span>
                        {item.altDescription ? (
                          <span data-part={getCheckoutPartProps("opt-in-description")}>
                            {item.altDescription}
                          </span>
                        ) : null}
                      </span>
                    ) : (
                      `${item.name}${
                        isCountrySelectActive
                          ? ` (${selectedCountry.short_name})`
                          : ''
                      }`
                    )
                  }
                  isChecked={optInSelection.includes(item.subscriptionId)}
                  checkIconSrc={getCheckoutCheckIconSrc()}
                />
                {!isBrandRefresh ? (
                  <p data-part={getCheckoutPartProps("opt-in-description")}>
                    {item.altDescription}
                  </p>
                ) : null}
              </div>
            ) : null;
          })}
        </div>
      </div>
    ) : null;
  };

  onExpandDeliveryAddress = expand => {
    this.setState({ deliveryAddressOpen: expand });
  };

  /**
   * Handle dropoff location change from map
   * @param {Object} data - {coords: {lat, lng}, distance: number, isValid: boolean}
   */
  onDropoffChange = data => {
    log.logInfo("[ReviewOrder] onDropoffChange called with", {
      coords: data?.coords
        ? { lat: data.coords.lat, lng: data.coords.lng }
        : null,
      distance: data?.distance,
      isValid: data?.isValid
    });
    const { coords, distance, isValid } = data;
    const { dropoffOrigin } = this.state;

    // Check if the coords differ from origin
    const hasChanged =
      dropoffOrigin &&
      (coords.lat !== dropoffOrigin.lat || coords.lng !== dropoffOrigin.lng);
    log.logInfo("[ReviewOrder] dropoffOrigin", { dropoffOrigin, hasChanged });

    this.setState({
      dropoffCandidate: coords,
      dropoffValid: isValid,
      dropoffDirty: isValid && hasChanged,
      dropoffDistance: distance
    });
  };

  /**
   * Submit dropoff location to backend
   */
  handleSetDropoffLocation = async () => {
    const { order, dropoffCandidate } = this.state;

    this.setState({ dropoffSaving: true });

    try {
      await orderRepo.updateDropoffLocation(order.code, dropoffCandidate);

      // Update origin to the new location and reset dirty state
      this.setState({
        dropoffOrigin: dropoffCandidate,
        dropoffSaving: false,
        dropoffDirty: false
      });
      const { lat, lng } = dropoffCandidate || {};
      if (lat != null && lng != null) {
        amplitudeAnalytics.trackSetDropoffLocation({
          latLong: `${lat}, ${lng}`,
        });
      }
    } catch (error) {
      this.setState({ dropoffSaving: false });
    }
  };

  /**
   * Check should render opt-in options
   * @return {boolean}
   */
  shouldRenderOptInOptions = () => {
    const { customerSubscriptions } = this.state;
    if (customerSubscriptions) {
      const alreadyOptInIds = customerSubscriptions.filter(item => {
        return (
          item.customerIdentifier !== null &&
          (item.keyField === "phone" || item.keyField === "email")
        );
      });
      return alreadyOptInIds.length !== 2;
    }
  };

  shouldRenderPhoneOptInOptions = () => {
    const { customerSubscriptions } = this.state;
    if (customerSubscriptions) {
      const alreadyOptInIds = customerSubscriptions.filter(item => {
        return item.customerIdentifier !== null && item.keyField === "phone";
      });
      return alreadyOptInIds.length !== 1;
    }
  };

  renderExtraTaxBlock = () => {
    const { showTaxesAfterTotal } = this.props;
    if (showTaxesAfterTotal) {
      return <div className={styles.extraTaxSection}>{this.taxes()}</div>;
    }
    return null;
  };

  renderSavingsBanner = () => {
    const { order, currency } = this.props;
    const totalDiscounts = order.discounts.reduce(
      (sum, discount) => sum + discount.value,
      0
    );
    const deliveryFeeDiscount = order?.totals
    ?.find(total => total?.title?.toLowerCase() === orderTotals.deliveryFeeDiscount.title.toLowerCase())
    ?.value ?? 0;
    const totalSavings = totalDiscounts + deliveryFeeDiscount;
    return totalSavings > 0 ? (
      <div
        className={`${styles.savingsBanner} px-4 py-1 text-center`}
        data-part={getCheckoutPartProps("savings-banner")}
      >
        <span className="font-bold text-sm">
          <i className="fa fa-tag mr-2" aria-hidden="true" />
          Saving 
          {' '}
          {currency.symbol} 
          {' '}
          {totalSavings.toFixed(2)}
          {' '}
          with promotions
        </span>
      </div>
    ) : null;
  };

  getOrderItems = order => {
    const { currency } = this.props;
    const orderRedeemables = order?.orderRedeemables
      ? order.orderRedeemables
      : [];
    const isBrandRefresh = isReviewOrderBrandRefresh();

    return order.items.map(item => {
      if (item.product) {
        const isRedeemable = orderRedeemables.find(
          p => p.order_product_id === item.id
        );
        let productOptionsPrice = 0;
        const productOptions = item.productOptions?.map(option => {
          const optionLinePrice = option.optionPrice
            ? option.optionPrice * option.quantity
            : 0;
          productOptionsPrice += optionLinePrice;
          // Brand refresh: option qty/title; paid upsell (+$x.xx) secondary — not multiplied by parent qty
          if (isBrandRefresh) {
            return (
              <div
                key={option.id}
                data-part={getCheckoutPartProps("line-item-option")}
              >
                <span data-part={getCheckoutPartProps("line-item-option-title")}>
                  {`${option.quantity} ${option.title}`}
                </span>
                {option.optionPrice > 0 ? (
                  <span data-part={getCheckoutPartProps("line-item-option-price")}>
                    {`(+${currency.symbol}${optionLinePrice.toFixed(2)})`}
                  </span>
                ) : null}
              </div>
            );
          }
          return (
            <div className="flex justify-between" key={option.id}>
              <p>{`${option.quantity} ${option.title}`}</p>
              <p>
                {`${
                  option.optionPrice
                    ? `${currency.symbol}${optionLinePrice.toFixed(2)}`
                    : ""
                }`}
              </p>
            </div>
          );
        });

        const amount = getOrderItemLineAmount({
          unitTotal: getTotalPrice(item),
          quantity: item.quantity,
          productOptionsPrice,
          isRedeemable: Boolean(isRedeemable),
          redeemablePrice: item.price,
        });

        if (isBrandRefresh) {
          const lineItem = (
            <div
              onClick={e => this.editUpsellProducts(item.product, item, e)}
              onKeyDown={e => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  this.editUpsellProducts(item.product, item, e);
                }
              }}
              role="button"
              tabIndex={0}
              aria-label={`Edit ${item.product.title} options`}
              data-part={getCheckoutPartProps("line-item")}
            >
              {returnLineCost(
                getOrderItemLabel(item.quantity, item.product.title),
                amount,
                false,
                currency,
                "product",
                true,
                false,
                null,
                false
              )}
            </div>
          );

          // Figma 9396:75667 — only group when options exist (gap 12 title → options)
          if (productOptions?.length) {
            return (
              <div
                key={item.id || item.product?.id}
                data-part={getCheckoutPartProps("order-item-group")}
              >
                {lineItem}
                <div data-part={getCheckoutPartProps("line-item-options")}>
                  {productOptions}
                </div>
              </div>
            );
          }

          return (
            <React.Fragment key={item.id || item.product?.id}>
              {lineItem}
            </React.Fragment>
          );
        }

        return (
          <>
            <div
              className="cursor-pointer font-bold text-lg"
              onClick={e => this.editUpsellProducts(item.product, item, e)}
              onKeyDown={e => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  this.editUpsellProducts(item.product, item, e);
                }
              }}
              role="button"
              tabIndex={0}
              aria-label={`Edit ${item.product.title} options`}
            >
              {returnLineCost(
                `${item.quantity} ${item.product.title}`,
                amount,
                false,
                currency,
                "product",
                true,
                false,
                null,
                false
              )}
            </div>
            <div
              className={`${styles.breakdownItem} text-dark dark:text-white `}
            >
              {productOptions}
            </div>
          </>
        );
      }
      return null;
    });
  };

  /**
   * @param {boolean} value - The boolean value to set.
   * @returns {void}
   */
  updateEmbeddedPaymentMethod = value => {
    this.setState({ embeddedPaymentMethod: value });

    const paymentMethod =
      value?.storePaymentMethod?.paymentMethod ?? value?.paymentMethod;
    delete paymentMethod?.variables;
    if (paymentMethod) {
      const { userCartId, order } = this.props;
      tagmanagerEvents.selectPaymentMethod(
        userCartId,
        paymentMethod,
        order?.customer?.id
      );
    }
    if (!this.checkOrderValidation()) {
      this.setState({
        isFormCompleted: false
      });
    } else {
      this.setState({
        isFormCompleted: true
      });
    }
  };

  editUpsellProducts = (product, item, event) => {
    if (item.productOptions.length > 0) {
      const { setUpsellProductModalActive } = this.props;
      setUpsellProductModalActive({
        openModal: true,
        product,
        item,
        triggeringElement: event?.currentTarget || event?.target
      });
    }
  };

  reviewOrderContainer = () => {
    const {
      customerSubscriptions,
      optInSelection,
      address2,
      order,
      orderLoading,
      orderLoadError,
      completeOrderError,
      completeOrderProcessing,
      orderCompleted,
      content: cmsContent,
      embeddedPaymentMethod,
      isFormCompleted,
      previousTotal,
    } = this.state;
    const {
      userToken,
      userOrderMethod,
      history,
      userCart,
      doughProMember,
      currency,
      upsellEdit,
      deliveryPickupWidgetEnable
    } = this.props;

    if (orderLoadError) {
      return (
        <div className={styles.loaderWrapper}>
          <p className={styles.errorMessage} role="alert">
            {orderLoadError}
          </p>
        </div>
      );
    }

    if (orderLoading || !order || userCart.length <= 0) {
      return (
        <div className={styles.loaderWrapper}>
          <Loader />
        </div>
      );
    }

    const total = previousTotal;
    const hasDeliveryDiscount = this.getHasDeliveryDiscount(order);
    const isShipping = userOrderMethod === orderMethods.shipping;
    const isPickup = order.orderTypeId === orderTypeIds.pickup;
    const isDelivery = order.orderTypeId === orderTypeIds.delivery;
    const isDoughPro = isDoughProOrder(order.orderTypeId);
    const isEmailGift = order.orderTypeId === orderTypeIds.eGiftCard;
    const isPlaceOrderDisabled = this.computeIsPlaceOrderDisabled();
    const customContainerClasses = isPlaceOrderDisabled
      ? `${styles.buttonContainer} Button_isDisabled`
      : styles.buttonContainer;
    const isBrandRefresh = isReviewOrderBrandRefresh();
    const placeOrderButton = (
      <Button
        handleSubmit={() => this.completeOrder()}
        customContainerStyles={customContainerClasses}
        label="Place Order"
      />
    );
    const placeOrderBlock = (
      <div
        className={styles.placeOrderStickyBar}
        data-part={isBrandRefresh ? "place-order-sticky" : undefined}
      >
        <div data-part={getCheckoutPartProps("place-order")}>
          {placeOrderButton}
        </div>
      </div>
    );
    const itemQuantity = _.chain(order?.items || [])
      .map("quantity")
      .reduce((a, b) => a + b, 0)
      .value();
    const disclaimerNotes = this.getDisclaimerNotes() || "";
    const disclaimerSMSNotes = this.getDisclaimerSMSNotes() || "";
    const { goToCartLabel, reviewOrderSubtext2 } = messages.viewOrder;
    const orderStatusSubscription = _.find(customerSubscriptions, {
      keyField: subscription.subscriptionKeyField.ORDER_NOTIFICATION
    });
    const apartmentPlaceholder = (
      cms.getValueByKey(
        cmsKeys.placeholders.checkoutDeliveryAddressApartment,
        this
      ) || "Add apartment#/suite#/dorm#"
    ).replace(/<\/?[^>]+(>|$)/g, "");
    const hasUpsellProducts =
      Array.isArray(order?.upsellProducts) && order.upsellProducts.length > 0;
    const showUpsellProducts =
      (isBrandRefresh || !isMobile()) &&
      (isPickup || isDelivery) &&
      userCart.length > 0 &&
      hasUpsellProducts;
    const paymentMethodGroups = getPaymentMethodGroups(
      order.store?.storePaymentMethods,
      typeof userToken === "string" ? order.customer?.cards : null
    );
    const isSavePaymentMethodCheckedAndDisabled =
      order.orderTypeId && isDoughProOrder(order.orderTypeId);
    const isEmbeddedPayment = embeddedPaymentMethod
      ? Object.values(embeddedPaymentMethod).some(item => {
          return (
            item?.isEmbeddedHtml &&
            item?.uiComponentType === uiComponentTypes.button
          );
        })
      : false;
    const headingBackIcon = getCheckoutBackIcon(backIcon, brandRefreshBackIcon);
    const displayTotal = this.calculateTotal();

    return (
      <div
        className={`${styles.pageWrapper} lg:max-w-screen-desktop mx-auto py-10 lg:px-0 overflow-hidden `}
        data-region={getCheckoutRegionProps()}
        data-part={getCheckoutPartProps("page-wrapper")}
      >
        {completeOrderProcessing || orderCompleted ? (
          <PlaceOrderLoader isCompleted={orderCompleted} />
        ) : (
          ""
        )}

        {upsellEdit?.openModal ? <UpsellProducts /> : null}
        <div
          className={`${styles.pageContainer} flex flex-col gap-4`}
          data-part={getCheckoutPartProps("page-container")}
        >
          {/* PAGE TITLE */}
          <button
            type="button"
            onClick={() => {
              amplitudeAnalytics.trackClickNavSecondary({
                navElement: goToCartLabel,
                navSection: AMPLITUDE_NAV_SECTION_SECONDARY.CHECKOUT,
                pathname: history.location?.pathname,
              });
              history.push(routeCountryPath(endpoints.checkoutViewOrderPage));
            }}
            className={
              isBrandRefresh
                ? undefined
                : `
              ${styles.pointer}
              cursor-pointer
              flex items-center font-congenialBlack text-4xl leading-9
              tracking-[-1px] gap-8 text-dark dark:text-white
              bg-transparent border-none outline-none font-inherit p-0`
            }
            aria-label={`Back to ${goToCartLabel}`}
            data-part={getCheckoutPartProps("heading")}
          >
            {isBrandRefresh ? (
              <>
                <span
                  aria-hidden="true"
                  data-part={getCheckoutPartProps("back-icon-button")}
                >
                  <span data-part={getCheckoutPartProps("back-icon")}>
                    <img
                      alt=""
                      src={headingBackIcon}
                      width={24}
                      height={24}
                    />
                  </span>
                </span>
                <span data-part={getCheckoutPartProps("heading-copy")}>
                  <span data-part={getCheckoutPartProps("title")}>
                    {goToCartLabel}
                  </span>
                  <span data-part={getCheckoutPartProps("subtitle")}>
                    {reviewOrderSubtext2}
                  </span>
                </span>
              </>
            ) : (
              <>
                <span aria-hidden="true">
                  <img alt="" src={backIcon} className="block dark:hidden" />
                  <img
                    alt=""
                    src={LightBackIcon}
                    className="hidden dark:block"
                  />
                </span>
                {goToCartLabel}
              </>
            )}
          </button>

          <div
            className={`
            ${styles.reviewOrderSubtitle}
            font-montserratMedium leading-5 text-dark dark:text-white`}
            data-part={getCheckoutPartProps("legacy-subtitle")}
          >
            {reviewOrderSubtext2}
          </div>

          {deliveryPickupWidgetEnable && <ToggleDeliveryPickup />}

          {/* SUGGESTED DELIVERY CAROUSEL */}
          {showUpsellProducts ? <UpsellProduct order={order} /> : null}

          {/* PAGE COLUMNS */}
          <div
            className={`${styles.columnsContainer} lg:grid grid-cols-3 gap-9 lg:gap-6 flex flex-col`}
            data-part={getCheckoutPartProps("columns")}
          >
            {/* USER DETAILS */}
            <div data-part={getCheckoutPartProps("fulfillment-column")}>
              <div
                className={`${styles.detailsContainer} flex flex-col gap-9`}
                data-part={getCheckoutPartProps("details-container")}
              >
                <div
                  className={`${styles.detailsSection}`}
                  data-part={getCheckoutPartProps('fulfillment-details-section')}
                >
                  {/* CONDITIONALLY RENDERED HEADERS */}
                  <h3
                    className={`
                    ${isShipping ? "shippingDetailsLabel" : null}
                    border-b-[3px] border-borderLight h-9 dark:border-darkBorder
                    font-montserratBold text-lg leading-[22px] tracking-[-0.1px] text-dark dark:text-white
                  `}
                    data-part={getCheckoutPartProps("section-title")}
                  >
                    {isShipping ? "Shipping Details" : null}
                    {isPickup ? "Pickup Details" : null}
                    {isDelivery ? "Delivery Details" : null}
                  </h3>

                  <div data-part={getCheckoutPartProps("fulfillment-panel")}>
                    {isShipping ? (
                      <div>
                        <div className={styles.shippingDetailsFields}>
                          <ShippingAddress />
                          <Input
                            inputId="addressApartment"
                            handleInput={e => {
                              validations.handleFormInput(e, this, "address2");
                            }}
                            value={address2}
                            customContainerStyles={styles.inputContainer}
                            placeholder=" "
                            label={apartmentPlaceholder}
                          />
                        </div>
                        {order.orderTypeId === orderTypeIds.shipping ? (
                          <ShippingMethods />
                        ) : null}
                        <GiftRecipient
                          orderStatusSubscription={orderStatusSubscription}
                          completeOrderError={completeOrderError}
                        />
                      </div>
                    ) : null}

                    {/* PICKUP RENDERINGS */}
                    {isPickup ? pickUpRenderings(this) : null}

                    {/* DELIVERY RENDERINGS */}
                    {isDelivery ? deliveryRendering(this) : null}
                  </div>
                </div>
                {/* CONTACT DETAILS */}
                {isShipping || isDelivery || isDoughPro || isEmailGift ? (
                  <div
                    className={isBrandRefresh ? 'yourContactDetailsLabel' : null}
                    data-part={getCheckoutPartProps("contact-section")}
                  >
                    {!isBrandRefresh ? null : (
                      <h3 data-part={getCheckoutPartProps("section-title")}>
                        Your Contact Details
                      </h3>
                    )}
                    <div data-part={getCheckoutPartProps("contact-panel")}>
                      <ContactDetailsWidget
                        orderStatusSubscription={orderStatusSubscription}
                        toggleSubscription={this.toggleOptInUpdate}
                        subscriptionSelections={optInSelection}
                        setContactFormError={this.setContactFormError}
                        completeOrderError={completeOrderError}
                      />
                    </div>
                  </div>
                ) : null}
              </div>
            </div>

            <div data-part={getCheckoutPartProps("payment-column")}>
              <div className={styles.detailsContainer}>
                <div className={styles.detailsSection}>
                  {isBrandRefresh ? (
                    <h3 data-part={getCheckoutPartProps("section-title")}>
                      Payment Info
                    </h3>
                  ) : (
                    <h3
                      className="
                    border-b-[3px] border-borderLight dark:border-darkBorder h-9
                    font-montserratBold text-lg leading-[22px] tracking-[-0.1px] text-dark dark:text-white
                  "
                    >
                      Payment Info
                    </h3>
                  )}
                  <div data-part={getCheckoutPartProps("payment-panel")}>
                    <PaymentWidget
                      sectionTitle="Payment Method"
                      userToken={userToken}
                      updatePaymentCredentials={credentials => {
                        return this.updatePaymentCredentials(credentials);
                      }}
                      order={order}
                      orderTypeId={order.orderTypeId}
                      paymentMethodsCustomerSaved={order.customer?.cards}
                      storePaymentMethods={order.store?.storePaymentMethods}
                      cmsContent={cmsContent}
                      isLoggedIn={typeof userToken === "string"}
                      isDoughProMember={doughProMember}
                      updateEmbeddedPaymentMethod={
                        this.updateEmbeddedPaymentMethod
                      }
                      orderTotal={total}
                      completeOrderError={completeOrderError}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div data-part={getCheckoutPartProps("order-summary-column")}>
              <div data-part={getCheckoutPartProps("order-summary-panel")}>
                {isBrandRefresh ? (
                  <h3 data-part={getCheckoutPartProps("section-title")}>
                    Order Summary
                  </h3>
                ) : (
                  <h3
                    className="
                    border-b-[3px] border-borderLight dark:border-darkBorder h-9
                    font-montserratBold text-lg leading-[22px] tracking-[-0.1px] text-dark dark:text-white
                  "
                  >
                    Order Summary
                  </h3>
                )}
                <div
                  className={`${styles.costDetails}`}
                  data-part={getCheckoutPartProps("order-summary-card")}
                >
                  <h3
                    className={
                      isBrandRefresh
                        ? undefined
                        : "text-dark dark:text-white bg-white dark:bg-dark px-6 py-4 shadow-md"
                    }
                    data-part={getCheckoutPartProps("order-items-header")}
                  >
                    <span data-part={getCheckoutPartProps("item-count")}>
                      {itemQuantity}
                      {' '}
                      Item Order
                    </span>
                    <div
                      className={isBrandRefresh ? undefined : styles.editButton}
                      data-part={getCheckoutPartProps("edit-order-wrap")}
                    >
                      <span
                        onClick={() => {
                          this.goToEditOrderFromCheckout();
                        }}
                        onKeyDown={e => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            this.goToEditOrderFromCheckout();
                          }
                        }}
                        role="button"
                        tabIndex={0}
                        aria-label="Edit Order"
                        data-part={getCheckoutPartProps("edit-order")}
                      >
                        Edit Order
                      </span>
                    </div>
                  </h3>
                  <div
                    className={`${styles.totalsContainer}`}
                    data-part={getCheckoutPartProps("order-totals")}
                  >
                    {isBrandRefresh ? (
                      <div data-part={getCheckoutPartProps("order-cart-body")}>
                        <div
                          data-part={getCheckoutPartProps("order-divider")}
                          aria-hidden="true"
                        />
                        <div data-part={getCheckoutPartProps("order-products")}>
                          {this.getOrderItems(order)}
                        </div>
                        <div
                          data-part={getCheckoutPartProps("order-divider")}
                          aria-hidden="true"
                        />
                        <div data-part={getCheckoutPartProps("order-fees")}>
                          {this.totals()}
                        </div>
                        <div
                          data-part={getCheckoutPartProps("order-divider")}
                          aria-hidden="true"
                        />
                        <div data-part={getCheckoutPartProps("order-total-row")}>
                          {returnLineCost(
                            "Total",
                            displayTotal,
                            false,
                            currency,
                            "orderTotal",
                            true,
                            false,
                            hasDeliveryDiscount
                              ? displayTotal + order.deliveryFeeDiscount
                              : null,
                            false
                          )}
                        </div>
                      </div>
                    ) : (
                      <>
                        <div
                          className={[
                            styles.totalsSection,
                            styles.products,
                            "bg-white dark:bg-dark px-4  shadow-md"
                          ].join(" ")}
                        >
                          {this.getOrderItems(order)}
                        </div>

                        {this.totals()}

                        <div
                          id={styles.total}
                          className={`${styles.totalsSection} bg-white dark:bg-dark px-4 shadow-md`}
                        >
                          <div className="border-t-[1px]" />
                          {returnLineCost(
                            "Total",
                            displayTotal,
                            false,
                            currency,
                            "orderTotal",
                            true,
                            false,
                            hasDeliveryDiscount
                              ? displayTotal + order.deliveryFeeDiscount
                              : null,
                            false
                          )}
                        </div>

                        {this.renderExtraTaxBlock()}

                        {this.renderSavingsBanner()}
                      </>
                    )}
                  </div>
                </div>

                {isBrandRefresh ? this.renderExtraTaxBlock() : null}
                {isBrandRefresh ? this.renderSavingsBanner() : null}
              </div>

              <div
                className={styles.actionsSection}
                data-part={getCheckoutPartProps("actions-section")}
              >
                {/* OPT-IN SECTION */}
                {this.renderOptInSection()}
                {this.renderOtpInput()}
                {completeOrderError && (
                    isBrandRefresh ? (
                      <>
                        <CheckoutAlertInline message={completeOrderError} />
                        {this.renderOtpResendBtn()}
                      </>
                    ) : (
                      <p
                        data-part={
                          completeOrderError ===
                          orderCompleteRequirementMessages.locationAccessAcknowledgement
                            ? "location-access-checkout-submit-error"
                            : undefined
                        }
                        className={styles.errorMessage}
                        role="alert"
                      >
                        {completeOrderError}
                        {this.renderOtpResendBtn()}
                      </p>
                    )
                  )}
                {!isBrandRefresh &&
                  isMobile() &&
                  (isPickup || isDelivery) &&
                  userCart.length > 0 &&
                  hasUpsellProducts ? (
                    <UpsellProduct order={order} />
                  ) : null}
                {userCart && userCart.length > 0 && !isEmbeddedPayment
                    ? placeOrderBlock
                    : undefined}
                {isEmbeddedPayment &&
                    paymentMethodGroups.map(pmcg => (
                      <div key={pmcg.groupTitle}>
                        <EmbeddedPaymentMethod
                          paymentMethodComponentGroup={pmcg}
                          isSavePaymentMethodCheckedAndDisabled={
                            isSavePaymentMethodCheckedAndDisabled
                          }
                          isSavePaymentMethodAllowed={
                            typeof userToken === "string"
                          }
                          paymentMethodsCustomerSaved={order.customer?.cards}
                          updatePaymentCredentials={credentials => {
                            return this.updatePaymentCredentials(credentials);
                          }}
                          isDoughProMember={doughProMember}
                          isLoggedIn={typeof userToken === "string"}
                          cmsContent={cmsContent}
                          embeddedPaymentMethod={embeddedPaymentMethod}
                          onSuccessPayment={() => this.completeOrder()}
                          isFormCompleted={isFormCompleted}
                        />
                      </div>
                    ))}

                {isBrandRefresh ? (
                  <div data-part={getCheckoutPartProps("disclaimers")}>
                    <p
                      ref={this.textDisclaimerRef}
                      className={`${styles.disclaimerNotes}`}
                      data-part={getCheckoutPartProps("disclaimer")}
                    >
                      {disclaimerNotes?.value ? (
                        <CmsInlineEdit
                          cmsNode={disclaimerNotes}
                          applyMarkdown={false}
                          applyMarkdownOnEdit={false}
                        >
                          <ReactMarkdown>
                            {disclaimerNotes?.value}
                          </ReactMarkdown>
                        </CmsInlineEdit>
                        ) : null}
                    </p>
                    <p
                      ref={this.smsDisclaimerRef}
                      className={`${styles.disclaimerSMSNotes}`}
                      data-part={getCheckoutPartProps("disclaimer")}
                    >
                      {disclaimerSMSNotes?.value ? (
                        <CmsInlineEdit
                          cmsNode={disclaimerSMSNotes}
                          applyMarkdown={false}
                          applyMarkdownOnEdit={false}
                        >
                          <ReactMarkdown>
                            {disclaimerSMSNotes?.value}
                          </ReactMarkdown>
                        </CmsInlineEdit>
                        ) : null}
                    </p>
                  </div>
                  ) : (
                    <>
                      <p
                        ref={this.textDisclaimerRef}
                        className={`${styles.disclaimerNotes} text-darkElevationPrimary dark:text-darkElevationSecondary`}
                        data-part={getCheckoutPartProps("disclaimer")}
                      >
                        {disclaimerNotes?.value ? (
                          <CmsInlineEdit
                            cmsNode={disclaimerNotes}
                            applyMarkdown={false}
                            applyMarkdownOnEdit={false}
                          >
                            <ReactMarkdown>
                              {disclaimerNotes?.value}
                            </ReactMarkdown>
                          </CmsInlineEdit>
                        ) : null}
                      </p>
                      <p
                        ref={this.smsDisclaimerRef}
                        className={`${styles.disclaimerSMSNotes} text-darkElevationPrimary dark:text-darkElevationSecondary`}
                        data-part={getCheckoutPartProps("disclaimer")}
                      >
                        {disclaimerSMSNotes?.value ? (
                          <CmsInlineEdit
                            cmsNode={disclaimerSMSNotes}
                            applyMarkdown={false}
                            applyMarkdownOnEdit={false}
                          >
                            <ReactMarkdown>
                              {disclaimerSMSNotes?.value}
                            </ReactMarkdown>
                          </CmsInlineEdit>
                        ) : null}
                      </p>
                    </>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  /**
   * Whether totals show a non-zero delivery fee and delivery fee discount line.
   */
  getHasDeliveryDiscount = order => {
    const totalsList = order?.totals ?? [];
    const toNumeric = value => {
      if (value === "Free" || value === null || value === undefined) {
        return 0;
      }
      if (typeof value === "number" && Number.isFinite(value)) {
        return value;
      }
      const parsed = parseFloat(value);
      return Number.isFinite(parsed) ? parsed : 0;
    };
    const deliveryRow = totalsList.find(
      t =>
        t?.title?.toLowerCase() === orderTotals.delivery.title.toLowerCase()
    );
    const discountRow = totalsList.find(
      t =>
        t?.title?.toLowerCase() ===
        orderTotals.deliveryFeeDiscount.title.toLowerCase()
    );
    const deliveryFee = deliveryRow ? toNumeric(deliveryRow.value) : 0;
    const deliveryFeeDiscountLine = discountRow
      ? toNumeric(discountRow.value)
      : 0;
    return deliveryFee !== 0 && deliveryFeeDiscountLine !== 0;
  };

  calculateTotal = () => {
    const { order } = this.state;
    const { checkout } = this.props;
    const totals = order?.totals || [];
    const toAmount = value => {
      const amount = Number(value);
      return Number.isFinite(amount) ? amount : 0;
    };
    const total = totals.find(item => item.title === orderTotals.total.title)
      ?.value;
    const tip = totals.find(item => item.title === orderTotals.tip.title)?.value;
    return toAmount(total) - toAmount(tip) + toAmount(checkout?.tip);
  };

  syncTotal = () => {
    const { previousTotal, embeddedPaymentMethod } = this.state;
    const total = this.calculateTotal();
    if (total === previousTotal) return;

    this.setState({ previousTotal: total });
    const isApplePayEmbeddedPayment = Object.values(
      embeddedPaymentMethod || {}
    ).some(
      item =>
        Number(item?.paymentMethodId) === Number(paymentMethods.applepay) &&
        item?.isEmbeddedHtml &&
        item?.uiComponentType === uiComponentTypes.button
    );
    if (isApplePayEmbeddedPayment) {
      document.dispatchEvent(
        new CustomEvent("updateTotal", { detail: { total } })
      );
    }
  };

  updateDoughProMember = async callback => {
    const { setDoughProMember } = this.props;
    const doughProMemberUpdated = await doughProRepo.doughProMember();

    if (!doughProMemberUpdated) {
      return;
    }

    setDoughProMember(doughProMemberUpdated.data.doughProMember);

    callback();
  };

  unavailableProductsFilter = data => {
    let completeProcess = true;
    const unavailableProducts = data.productAvailabilityCheck;

    const existUnavailableProducts = unavailableProducts.length > 0;
    if (existUnavailableProducts) {
      let titles = "";
      unavailableProducts.forEach(item => {
        titles += `,${item.title}`;
      });

      const prodTitles = titles.substr(1, titles.length);
      this.renderOrderProcessingModal(completeProcess, prodTitles);
    } else {
      completeProcess = false;
      this.setState({
        completeOrderProcessing: completeProcess
      });
      this.renderOrderProcessingModal(completeProcess);
    }
  };

  checkRequiredContactFields = sender => {
    if (!sender) {
      return false;
    }

    const requiredFields = ["firstName", "lastName", "phone", "email"];
    let isError = false;

    requiredFields.forEach(field => {
      if (sender[field] == null || sender[field] === "") {
        isError = true;
      }
    });

    return !isError;
  };

  resolveRequirementScrollTarget = (elementClassName) => {
    if (!elementClassName) {
      return null;
    }

    if (
      isReviewOrderBrandRefresh()
      && elementClassName === orderCompleteRequirementClassNames.PaymentMethod
    ) {
      const paymentMethodAnchor = document.querySelector(
        '[data-region="checkout"] [data-part="payment-method-expander"]'
      );
      if (paymentMethodAnchor) {
        return (
          paymentMethodAnchor.closest('[data-part="payment-method-group"]')
          || paymentMethodAnchor
        );
      }
    }

    const byClassName = document.getElementsByClassName(elementClassName)[0];
    if (byClassName) {
      return byClassName;
    }

    if (!isReviewOrderBrandRefresh()) {
      return null;
    }

    const brandRefreshQueryByClassName = {
      [orderCompleteRequirementClassNames.contactDetails]: '[data-region="checkout"] [data-part="contact-section"]',
      [orderCompleteRequirementClassNames.deliveryTime]: '[data-region="checkout"] .selectDeliveryTime',
      [orderCompleteRequirementClassNames.pickupTime]: '[data-region="checkout"] .selectPickupTime',
      [orderCompleteRequirementClassNames.shippingDetails]: '[data-region="checkout"] .shippingDetailsLabel',
    };

    const query = brandRefreshQueryByClassName[elementClassName];
    return query ? document.querySelector(query) : null;
  };

  scrollToRequirementSection = (elementClassName, elementSelector) => {
    if (!isMobile()) {
      return;
    }

    if (elementSelector) {
      const scrollElement = elementSelector.startsWith("[")
        ? document.querySelector(elementSelector)
        : document.getElementsByClassName(elementSelector)[0];
      const yPos = scrollElement?.getBoundingClientRect
        ? scrollElement.getBoundingClientRect().top
          + window.pageYOffset
          - checkoutRequirementScrollHeaderOffset
        : null;
      if (yPos) {
        window.scrollTo({ top: yPos, left: 0, behavior: 'smooth' }); // eslint-disable-line
      }
      return;
    }

    if (!elementClassName) {
      return;
    }

    if (!isReviewOrderBrandRefresh()) {
      const element = document.getElementsByClassName(elementClassName)[0];
      const yPos = element?.offsetTop
        ? element.offsetTop - checkoutRequirementScrollHeaderOffset
        : null;
      if (yPos) {
        window.scrollTo({ top: yPos, left: 0, behavior: 'smooth' }); // eslint-disable-line
      }
      return;
    }

    const maxAttempts = 3;

    const attemptScroll = (attempt) => {
      const element = this.resolveRequirementScrollTarget(elementClassName);
      if (element) {
        const top = element.getBoundingClientRect().top
          + window.pageYOffset
          - checkoutRequirementScrollHeaderOffset;
        window.scrollTo({ top: Math.max(0, top), left: 0, behavior: 'smooth' }); // eslint-disable-line
        return;
      }

      if (attempt + 1 < maxAttempts) {
        requestAnimationFrame(() => attemptScroll(attempt + 1));
      }
    };

    requestAnimationFrame(() => attemptScroll(0));
  };

  computeIsPlaceOrderDisabled = () => {
    const {
      order,
      completeOrderProcessing,
      selectedDeliveryTime,
      previousTotal
    } = this.state;
    const {
      paymentCredentials,
      orderUpdating,
      selectedStoreHours,
      checkout
    } = this.props;

    const total = previousTotal;
    const isPickup = order.orderTypeId === orderTypeIds.pickup;
    const isDelivery = order.orderTypeId === orderTypeIds.delivery;
    const requiredDeliveryTime = !selectedDeliveryTime && isDelivery;
    const requiredPickupTime = !selectedDeliveryTime && isPickup;
    const isDoughPro = isDoughProOrder(order.orderTypeId);
    const needDoughProCustomerPhoneVerified =
      (order?.customer?.telephoneVerificationRequired || false) &&
      isDoughPro &&
      order.customer &&
      !order.customer.telephoneVerified;
    const isRecipientOk = this.checkRecipientFields(checkout);
    const errorsInCheckout =
      checkout && checkout.errors ? Object.values(checkout.errors) : [];

    return (
      !isRecipientOk ||
      requiredDeliveryTime ||
      requiredPickupTime ||
      !this.checkRequiredContactFields(checkout.sender) ||
      (!paymentCredentials && total > 0) ||
      completeOrderProcessing ||
      orderUpdating ||
      (!isDoughPro && !order.shippingMethod) ||
      (!isDoughPro && !order.shippingMethod.id) ||
      isStoreClosed(selectedStoreHours) ||
      errorsInCheckout.length ||
      needDoughProCustomerPhoneVerified ||
      this.isLocationAccessCheckoutBlockingOrder()
    );
  };

  getRequirementMessagesData = () => {
    const { order, selectedDeliveryTime, previousTotal } = this.state;
    const { paymentCredentials, userOrderMethod, checkout } = this.props;

    if (this.isLocationAccessCheckoutBlockingOrder()) {
      return {
        message:
          orderCompleteRequirementMessages.locationAccessAcknowledgement,
        elementSelector:
          '[data-part="location-access-checkout-reminder"]'
      };
    }

    const isPickup = order?.orderTypeId === orderTypeIds.pickup;
    const isDelivery = order?.orderTypeId === orderTypeIds.delivery;
    const isShipping = userOrderMethod === orderMethods.shipping;

    const requiredDeliveryTime = !selectedDeliveryTime && isDelivery;
    const requiredPickupTime = !selectedDeliveryTime && isPickup;
    const isDoughPro = isDoughProOrder(order.orderTypeId);
    const needDoughProCustomerPhoneVerified =
      order?.customer?.telephoneVerificationRequired &&
      isDoughPro &&
      order.customer &&
      (!order.customer.telephoneVerified || !!order.customer.telephoneNew);
    const requiredShipping =
      ((!isDoughPro && !order.shippingMethod) ||
        (!isDoughPro && !order.shippingMethod.id)) &&
      isShipping;

    let message = "";
    let elementClassName = null;
    const total = previousTotal;
    const requiredPaymentCredentials = !paymentCredentials && total > 0;
    const errorsInCheckout =
      checkout && checkout.errors ? Object.values(checkout.errors) : [];

    if (errorsInCheckout.length) {
      message = errorsInCheckout[0][0].message;
      elementClassName = errorsInCheckout[0][0].selector;
    } else if (requiredShipping) {
      message = orderCompleteRequirementMessages.shippingDetails;
      elementClassName = orderCompleteRequirementClassNames.shippingDetails;
    } else if (requiredDeliveryTime) {
      message = orderCompleteRequirementMessages.deliveryTime;
      elementClassName = orderCompleteRequirementClassNames.deliveryTime;
    } else if (requiredPickupTime) {
      message = orderCompleteRequirementMessages.pickupTime;
      elementClassName = orderCompleteRequirementClassNames.pickupTime;
    } else if (
      !checkout?.sender ||
      !this.checkRequiredContactFields(checkout.sender) ||
      needDoughProCustomerPhoneVerified
    ) {
      message = orderCompleteRequirementMessages.contactDetails;
      elementClassName = orderCompleteRequirementClassNames.contactDetails;
    } else if (requiredPaymentCredentials) {
      message = orderCompleteRequirementMessages.PaymentMethod;
      elementClassName = orderCompleteRequirementClassNames.PaymentMethod;
    }
    return { message, elementClassName };
  };

  getUnavailableProducts = () => {
    const { order } = this.props;
    orderRepo.orderProductsAvailability(order.code).then(response => {
      this.unavailableProductsFilter(response.data);
    });
  };

  updatePaymentCredentials = paymentCredentials => {
    const { paymentCredentialsUpdated } = this.props;
    if (paymentCredentialsUpdated) {
      this.setState({
        completeOrderProcessing: false,
        completeOrderError: ""
      });
      paymentCredentialsUpdated(paymentCredentials);
    }
    return Promise.resolve(paymentCredentials);
  };

  resetInstructions = () => {
    const { checkout, checkoutUpdated } = this.props;
    checkout.includeSpoon = false;
    checkout.orderComment = "";
    checkoutUpdated(checkout);
  };

  checkRecipientFields = checkout => {
    if (checkout.isGift === true) {
      checkout.giftContact = {
        firstName: checkout.giftFirstName || "",
        lastName: checkout.giftLastName || "",
        phone: checkout.giftPhone || "",
        message: checkout.giftMessage || ""
      };
      if (
        checkout.giftContact.firstName === "" ||
        checkout.giftContact.lastName === "" ||
        checkout.giftContact.phone === ""
      ) {
        checkout.errors.gift_common = [
          {
            message: orderCompleteRequirementMessages.giftRecipient,
            selector: orderCompleteRequirementClassNames.giftArea,
          },
        ];
        return false;
      }
      if (checkout.errors.gift_common) {
        delete checkout.errors.gift_common;
      }
    } else {
      delete checkout.giftContact;
      if (checkout.errors && typeof checkout.errors === "object") {
        Object.keys(checkout.errors).forEach(key => {
          if (/^gift_/.test(key)) {
            delete checkout.errors[key];
          }
        });
      }
    }
    return true;
  };

  redirectIfCartInvalid() {
    const {
      history,
      userAddress,
      selectedStore,
      userCart,
      order,
      userOrderMethod,
      currency,
      toggleCartMenu
    } = this.props;

    if (!userAddress || !order || !selectedStore) {
      history.push(routeCountryPath("/"));
      return;
    }

    const isCartEmpty = userCart.length === 0;
    const subTotal = getCartSubtotal(userCart);
    const minAmount = order.shippingMethodMinAmount ?? 0;

    const isDeliveryOrder = userOrderMethod === orderMethods.delivery;
    const isBelowMinAmount = subTotal < minAmount;
    const isInvalidDeliveryOrder = isDeliveryOrder && isBelowMinAmount;

    const shouldRedirect = isCartEmpty || isInvalidDeliveryOrder;

    if (!shouldRedirect) return;

    if (isCartEmpty) {
      checkoutWithNoItems();
    } else {
      checkoutOrderMinAmount(minAmount, currency.symbol);
    }

    const isShippingStore = selectedStore.id === storeIds.shipping;
    const menuPath = isShippingStore
      ? endpoints.shippingPage
      : endpoints.getMenuUrl(selectedStore);

    history.push(routeCountryPath(menuPath));
    toggleCartMenu();
  }

  checkOrderValidation() {
    return !this.computeIsPlaceOrderDisabled();
  }

  completeOrder() {
    const {
      address2,
      order,
      selectedDeliveryTime,
      orderOTP,
      optInSelection,
      previousTotal
    } = this.state;
    const {
      match,
      history,
      paymentCredentials,
      alertSenderPhone,
      alertRecipientPhone,
      setModalObject,
      checkout,
      checkoutErrorsUpdated,
      saveCredentials,
      setSaveCredentials,
      setLastCompletedOrderCode,
      checkoutUpdated,
      userAddress,
      setGuestSelectedStore,
      setGuestUserOrderMethod,
      setGuestUserAddress,
      selectedStore
    } = this.props;

    const isPlaceOrderDisabled = this.computeIsPlaceOrderDisabled();

    const orderCode = match.params.id;
    if (isPlaceOrderDisabled) {
      const messagesData = this.getRequirementMessagesData();
      this.setState({
        completeOrderError: messagesData.message,
        completeOrderProcessing: false
      }, () => {
        this.scrollToRequirementSection(
          messagesData.elementClassName,
          messagesData.elementSelector
        );
      });
      return;
    }
    let completeProcess = true;
    try {
      amplitudeAnalytics.trackPlaceOrder(order, store.getState());
    } catch {
      /* Amplitude must not affect checkout */
    }
    this.setState({
      completeOrderProcessing: completeProcess,
      completeOrderError: ""
    });
    this.renderOrderProcessingModal(completeProcess);

    const subscriptionIds = optInSelection || [];
    const { locationLabel } = checkout;
    const {
      sender,
      giftContact,
      orderComment,
      tip,
      includeSpoon,
      isContactlessDelivery
    } = checkout;
    const today = moment().startOf("day");
    const asap = moment(selectedDeliveryTime).isSame(today);
    const deliveryTime = asap ? "0000-00-00 00:00:00" : selectedDeliveryTime;
    const checkCreditDebitEmbedded =
      paymentCredentials !== null &&
      paymentCredentials.paymentMethodId === paymentMethods.creditdebitembedded;
    if (checkCreditDebitEmbedded) {
      paymentCredentials.saveCredentials = saveCredentials;
    }

    orderRepo
      .completeOrderV2(
        orderCode,
        deliveryTime,
        sender,
        giftContact,
        orderComment,
        paymentCredentials,
        orderOTP,
        address2,
        alertSenderPhone,
        alertRecipientPhone,
        subscriptionIds,
        tip,
        includeSpoon,
        isContactlessDelivery,
        locationLabel
      )
      .then(() => {
        const { checkout: checkoutSlice } = this.props;
        const { dropoffValid, dropoffDirty } = this.state;
        const tipsSettings = store.getState().tips?.tipsSettings;
        const dropoffLocationSet =
          order.orderTypeId === orderTypeIds.delivery &&
          Boolean(dropoffValid && dropoffDirty);
        try {
          amplitudeAnalytics.trackCompleteOrder(order, store.getState(), {
            checkout: checkoutSlice,
            checkoutTotal: previousTotal,
            tipsSettings,
            dropoffLocationSet,
          });
        } catch {
          /* Amplitude must not affect checkout */
        }

        this.setState({
          completeOrderProcessing: false,
          orderCompleted: true
        });

        tagmanagerEvents.purchase(order, false);

        const isCustomerOrder = !!order?.customer?.id;

        if (!isCustomerOrder) {
          setGuestSelectedStore(selectedStore);
          setGuestUserOrderMethod(order.orderTypeId);
          setGuestUserAddress(userAddress);
        }

        let historyUrl = isCustomerOrder
          ? endpoints.checkoutConfirmationPage.replace(":id", order.code)
          : endpoints.orderLoyalty.replace(":id", order.code);

        if (isDoughProOrder(order.orderTypeId)) {
          historyUrl = endpoints.homePage;
          tagmanagerEvents.joinCookieMagic({
            id: order.customer.id,
            firstname: order.customer.firstname,
            lastname: order.customer.lastname,
            email: order.customer.email
          });

          this.updateDoughProMember(() => {});
        }

        log.logInfo("[ReviewOrder][completeOrder]", {
          Order: order,
          orderCompleted: this.state?.orderCompleted
        });
        client.cache.evict({
          fieldName: "me"
        });
        client.cache.gc();
        checkoutUpdated({});
        setSaveCredentials(false);
        this.resetInstructions();
        setLastCompletedOrderCode(orderCode);
        setTimeout(() => {
          history.push(routeCountryPath(historyUrl));
        }, 1000);
      })
      .catch(reason => {
        const validationErrors = validations.getValidationErrorMessagesFromApiError(
          reason
        );
        const checkoutErrors = {};

        if (validationErrors.length) {
          validationErrors.forEach(err => {
            checkoutErrors[`${err.component}_${err.field}`] = [
              { message: err.message, selector: err.component }
            ];
          });

          checkoutErrorsUpdated(checkoutErrors);
        }

        let { message } =
          reason.graphQLErrors && reason.graphQLErrors[0]
            ? reason.graphQLErrors[0]
            : reason;

        if (Object.values(checkoutErrors).length) {
          message = Object.values(checkoutErrors)[0][0].message;
        }

        const reasonType = getErrorReasons(reason, 0);

        const unavailableProductReasonType =
          reasonType === errorCodes.COMPLETE_ORDER_UNAVAILABLE_PRODUCT;
        const missingAddressReasonType =
          reasonType === errorCodes.COMPLETE_ORDER_ADDRESS_MISS;
        if (unavailableProductReasonType) {
          this.getUnavailableProducts();
        } else if (missingAddressReasonType) {
          setModalObject(
            openAddressMissingOrderModal(this.backToMenu, message)
          );
        } else {
          completeProcess = false;
          this.setState({
            completeOrderErrorCode: getErrorReasons(reason, 0),
            completeOrderError: message,
            completeOrderProcessing: completeProcess
          });
          this.renderOrderProcessingModal(completeProcess);
          document.dispatchEvent(
            new CustomEvent("onPaymentProcessingError", {
              detail: { message, errorCode: reasonType }
            })
          );
        }
      });
  }

  render() {
    return <this.reviewOrderContainer />;
  }
}

ReviewOrder.propTypes = {
  history: PropTypes.shape().isRequired,
  orderUpdated: PropTypes.func.isRequired,
  checkoutUpdated: PropTypes.func.isRequired,
  order: PropTypes.shape().isRequired,
  checkout: PropTypes.shape().isRequired,
  currency: PropTypes.objectOf(PropTypes.string),
  isCountrySelectActive: PropTypes.bool,
  selectedCountry:
    PropTypes.shape({
      short_name: PropTypes.string,
      id: PropTypes.number,
      name: PropTypes.string
    }) || null,
  setLastCompletedOrderCode: PropTypes.func,
  toggleCartMenu: PropTypes.func
};

ReviewOrder.defaultProps = {
  currency: defaultCurrency,
  isCountrySelectActive: false,
  selectedCountry: null,
  setLastCompletedOrderCode: () => {},
  toggleCartMenu: () => null
};

export const mapStateToProps = state => {
  const {
    userOrderMethod,
    userCart,
    userAddress,
    selectedStore,
    userCartId,
    userToken,
    selectedStoreHours,
    alertRecipientPhone,
    alertSenderPhone
  } = state.user;
  const { orderUpdating } = state.payment;
  const { currency } = state.currency;
  const { saveCredentials } = state.ccDetails;
  const { showTaxesAfterTotal, orderTotalsTitles } = state.orderTotalsTitles;
  const { selectedCountry, isCountrySelectActive } = state.country;
  return {
    userOrderMethod,
    userCart,
    userAddress,
    selectedStore,
    userCartId,
    userToken,
    order: state.order,
    checkout: state.checkout,
    paymentCredentials: state.payment.credentials,
    orderUpdating,
    selectedStoreHours,
    alertRecipientPhone,
    alertSenderPhone,
    currency,
    saveCredentials,
    showTaxesAfterTotal,
    orderTotalsTitles,
    selectedCountry,
    isCountrySelectActive,
    upsellEdit: state.product?.upsellEdit,
    deliveryPickupWidgetEnable: state.elements.deliveryPickupWidgetEnable,
    locationAccessAcknowledgedStoreId: state.elements.locationAccessAcknowledgedStoreId,
  };
};

export const mapDispatchToProps = dispatch => ({
  setUserOrderMethod: value => dispatch(userActions.setUserOrderMethod(value)),
  setUserAddress: value => dispatch(userActions.setUserAddress(value)),
  setSelectedStore: value => dispatch(userActions.setSelectedStore(value)),
  setModalObject: value => dispatch(elementsActions.setModalObject(value)),
  setUserCart: value => dispatch(userActions.setUserCart(value)),
  setUserCartId: value => dispatch(userActions.setUserCartId(value)),
  setOrderCompleted: value => dispatch(userActions.setOrderCompleted(value)),
  orderUpdated: value => dispatch(orderActions.orderUpdated(value)),
  checkoutUpdated: value => dispatch(checkoutActions.checkoutUpdated(value)),
  checkoutErrorsUpdated: value =>
    dispatch(checkoutActions.checkoutErrorsUpdated(value)),
  setDoughProMember: value => dispatch(userActions.setDoughProMember(value)),
  setAlertRecipientPhoneUpdated: value =>
    dispatch(userActions.setAlertRecipientPhone(value)),
  setAlertSenderPhoneUpdated: value =>
    dispatch(userActions.setAlertSenderPhone(value)),
  setLastCompletedOrderCode: value =>
    dispatch(userActions.setLastCompletedOrderCode(value)),
  contentCardSession: value => dispatch(brazeActions.contentCardSession(value)),
  paymentCredentialsUpdated: value =>
    dispatch(paymentActions.paymentCredentialsUpdated(value)),
  setSaveCredentials: value =>
    dispatch(ccDetailsActions.setSaveCredentials(value)),
  setSaveCheckoutDetails: value =>
    dispatch(checkoutActions.setSaveCheckoutDetails(value)),
  setUpsellProductModalActive: value =>
    dispatch(productActions.setUpsellProductModalActive(value)),
  toggleCartMenu: value => dispatch(elementsActions.toggleCartMenu(value)),
  setGuestSelectedStore: value =>
    dispatch(guestUserActions.setGuestSelectedStore(value)),
  setGuestUserOrderMethod: value =>
    dispatch(guestUserActions.setGuestUserOrderMethod(value)),
  setGuestUserAddress: value =>
    dispatch(guestUserActions.setGuestUserAddress(value)),
  setLocationAccessAcknowledgedStoreId: value =>
    dispatch(elementsActions.setLocationAccessAcknowledgedStoreId(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReviewOrder);
